// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"statusBadge_statusBadge__2dvSA"};